/*eslint-disable eqeqeq*/
import React from "react";
import * as APIController from '../../../../../api/APIController.js';
import Table from "../../../../../shared/components/table/table";
import TableHead from "../../../../../shared/components/table/tableHead";
import TableRow from "../../../../../shared/components/table/tableRow";
import TableBody from "../../../../../shared/components/table/tableBody";
import TableCell from "../../../../../shared/components/table/tableCell";
import double_left_arrow from '../../../../../assets/images/left-doble-arow.svg';
import left_arrow from '../../../../../assets/images/left-arrow.svg';
import double_right_arrow from '../../../../../assets/images/right-doble-arow.svg';
import right_arrow from '../../../../../assets/images/right-arrow.svg';
import "react-perfect-scrollbar/dist/css/styles.css";

import PerfectScrollbar from "react-perfect-scrollbar";

import deleteIcon from '../../../../../assets/images/delete.svg'
import editIcon from '../../../../../assets/images/edit.svg'
import filtericon from '../../../../../assets/images/ic_feather_filter.svg'
import ConfirmtionDialog from '../../../../ConfirmDialog/ConfirmationDialog';
import Notification from '../../../../../shared/components/notification/notification';
import Modal from '../../../../../shared/components/modal/modal';
import CircularProgress from "../../../../../shared/components/CircularProgress/CircularProgress";
import PageTitle from "../../../../../config/pageTitle";

const LensestypeList = (props) => {

	const headerList = ['action', "Name", "Brand", "Sequence #", "Is active ?", "Is Daily Lens"]
	const { currentPage,
		count,
		rowsPerPage,
		rowsPerPageOptions,
		list, to, from } = props;
	let lensestypeList = list;

	const [LoginDialog, setLoginDialog] = React.useState(false);
	const [DeleteId, setDeleteId] = React.useState('');

	const [BrandName, setBrandName] = React.useState('');
	const [NameText, setNameText] = React.useState('');
	const [SequenceNo, setSequenceNo] = React.useState('');
	const [IsActive, setIsActive] = React.useState('');
	const [IsDailyLense, setIsDailyLense] = React.useState('');

	const page = rowsPerPage == 1000000 ? 1 : Math.floor(count / rowsPerPage) + 1;
	// const page = Math.floor(count / rowsPerPage) + 1;

	const handleChangeInCurrentPage = (value) => {
		if (value <= page && Number(parseInt(value))) {
			props.handleChangePage(Number(value), BrandName, NameText, SequenceNo, IsActive, IsDailyLense);
		}
	}

	const wsDeleteLensesType = (ID) => {
		APIController.DeleteLensesType(ID)
			.then((response) => {
				if (response.error == null) {
					if (response.object.status == 1) {
						handleNotification(response.object.message);
					} else {
						handleNotification(response.object.message, true);
					}
					props.handlebind()
					setLoginDialog(false)
				}
				else if (response.error.message && response.error.message.length > 0) {
					handleNotification(response.error.message, true);
				}
			})
	}

	const [message, setMessage] = React.useState("");
	const [showNotification, setShowNotification] = React.useState(false);
	const [isError, setIsError] = React.useState(false);

	const handleNotification = (message, isError) => {
		setMessage(message)
		setShowNotification(true)
		setIsError(isError)

		setTimeout(() => {
			handleClearNotification();
		}, 4000)
	}

	const handleClearNotification = () => {
		setMessage('')
		setShowNotification(false)
		setIsError(false)
	}

	const _handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			props.applyFilter(BrandName, NameText, SequenceNo, IsActive, IsDailyLense)
		}
	}

	return (
		<>
			<h1><PageTitle Title="View Lenses Types" /></h1>
			<div className="table-main-wrap">
				<PerfectScrollbar component='div'>
					<Table className="">
						<TableHead>
							<TableRow>
								{/* style={index == 0 ? { width: '5%' } : headerList.length - 1 == index || headerList.length - 2 == index || headerList.length - 3 == index ? { width: '5%' } : { width: '25%' }}  */}
								{headerList.map((obj, index) => { return <TableCell className={obj === "Is active ?" || obj === "Is Daily Lens" ? 'center' : ''} key={index}>{obj}</TableCell>; })}
							</TableRow>
							<TableRow>
								<TableCell style={{ minWidth: '10px', maxWidth: '15px', width: '15px' }}> <span><img src={filtericon} alt="delete" /></span> </TableCell>
								<TableCell style={{ minWidth: '150px', maxWidth: '200px', width: '200px' }}> <input type="text" name="" placeholder="Name" onKeyDown={_handleKeyDown} onChange={(e) => setNameText(e.target.value)} /> </TableCell>
								<TableCell style={{ minWidth: '150px', maxWidth: '200px', width: '200px' }}> <input type="text" name="" placeholder="Brand" onKeyDown={_handleKeyDown} onChange={(e) => setBrandName(e.target.value)} /> </TableCell>
								<TableCell style={{ minWidth: '20px', maxWidth: '50px', width: '10px' }}> <input type="text" name="" placeholder="Sequence #" onKeyDown={_handleKeyDown} onChange={(e) => setSequenceNo(e.target.value)} /> </TableCell>
								<TableCell style={{ minWidth: '100px', maxWidth: '150px', width: '150px' }}>
									<select onChange={(e) => { setIsActive(e.target.value); props.applyFilter(BrandName, NameText, SequenceNo, e.target.value, IsDailyLense) }}>
										<option value={""}>All</option>
										<option value={"1"}>Yes</option>
										<option value={"0"}>No</option>
									</select>
								</TableCell>
								<TableCell style={{ minWidth: '100px', maxWidth: '150px', width: '150px' }}>
									<select onChange={(e) => { setIsDailyLense(e.target.value); props.applyFilter(BrandName, NameText, SequenceNo, IsActive, e.target.value) }}>
										<option value={""}>All</option>
										<option value={"1"}>Yes</option>
										<option value={"0"}>No</option>
									</select>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!!lensestypeList.length ? lensestypeList.map((obj, idnex) => {
								return (
									<TableRow key={idnex}>
										<TableCell style={{ minWidth: '10px', maxWidth: '15px', width: '15px' }}>
											<span>
												<img src={editIcon} alt="edit" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => {
														props.history.push({
															pathname: '/supplytool/lensestype/add',
															state: { lensestypeIdEdit: obj.ID }
														})
													}} />
												<img src={deleteIcon} alt="delete" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => {
														setDeleteId(obj.ID)
														setLoginDialog(true)
													}} />
											</span>
										</TableCell>
										<TableCell style={{ minWidth: '150px', maxWidth: '200px', width: '200px' }}> {obj.Name} </TableCell>
										<TableCell style={{ minWidth: '150px', maxWidth: '200px', width: '200px' }}> {obj.BrandName} </TableCell>
										<TableCell style={{ minWidth: '20px', maxWidth: '50px', width: '10px' }}> {obj.SequenceNo} </TableCell>
										<TableCell style={{ minWidth: '100px', maxWidth: '150px', width: '150px' }} className={obj.IsActiveLABEL === "YES" ? 'green' : 'red'}>
											<span>{obj.IsActiveLABEL === "YES" ? 'Yes' : 'No'}</span>
										</TableCell>
										<TableCell style={{ minWidth: '100px', maxWidth: '150px', width: '150px' }} className={obj.IsDailyLenseLABEL === "YES" ? 'green' : 'red'}>
											<span>{obj.IsDailyLenseLABEL === "YES" ? 'Yes' : 'No'}</span>
										</TableCell>
									</TableRow>
								);
							}) : <TableRow>
								<TableCell colSpan={headerList.length} className="not_found">
									{props.progress ? <CircularProgress /> : <label>Not Currently Available</label>}
								</TableCell>
							</TableRow>}
						</TableBody>
					</Table>
				</PerfectScrollbar>
			</div>
			<Notification
				isError={isError}
				message={message}
				showNotification={showNotification}
				clearNotification={handleClearNotification.bind(this)}
				closeNotification={handleClearNotification.bind(this)}
			/>
			{LoginDialog && (
				<Modal
					show={LoginDialog}
					handleClose={() => setLoginDialog(false)}>
					<ConfirmtionDialog
						title={"Delete Lenses Type"}
						description={"Are you sure you want to delete this Lenses Type?"}
						deletePress={() => wsDeleteLensesType(DeleteId)}
						closeModal={() => setLoginDialog(false)}
					/>
				</Modal>
			)}
			<div className="table-pagination">
				<div className="pagination-info">
					<p>Showing {from + 1} - {to > count ? count : to} of {count}</p>
				</div>
				<div className="pagination-control">
					<a href="#!" title="" className={`double-left-arrow ${props.currentPage == 1 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(1)
						}}
					><img src={double_left_arrow} alt="left" /></a>
					<a href="#!" title="" className={`simple-left-arrow ${props.currentPage == 1 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage - 1)
						}}
					><img src={left_arrow} alt="single_left" /></a>
					<span>Page</span>
					<input disabled type="text" name="textbox" value={currentPage === 0 ? currentPage + 1 : currentPage} onChange={(e) => handleChangeInCurrentPage(e.target.value)} />
					<span>of {page}</span>
					<a href="#!" title="" className={`simple-right-arrow ${currentPage == page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage + 1)
						}}
					><img src={right_arrow} alt="right" /></a>
					<a href="#!" title="" className={`double-right-arrow ${currentPage == page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(page)
						}}><img src={double_right_arrow} alt="single_right" /></a>
					<select onChange={(e) => props.handleChangeRowsPerPage(parseInt(e.target.value), BrandName, NameText, SequenceNo, IsActive, IsDailyLense)} defaultValue={rowsPerPage}>
						{
							rowsPerPageOptions.map((obj, index) => {
								return <option value={obj} key={index}>{obj}</option>
							})
						}
					</select>
				</div>
			</div>
		</>
	);
};

export default LensestypeList;
